import { useEffect } from "react";
import { useRouteMatch } from "react-router-dom";
import { Locator, useSetFallbackUrl } from "./AppHistoryProvider";

export const useFallbackUrl = (fallbackUrl?: Locator) => {
  const setFallbackUrl = useSetFallbackUrl();
  // NOTE: Because multiple components can mount simultaneously and as a result
  // multiple `useFallbackUrl()` calls can be happening asynchronously, we use
  // the `isExact` flag to ensure only the calls originating from the component
  // that exact matched the current URL path takes effect
  const { isExact } = useRouteMatch();

  useEffect(() => {
    if (fallbackUrl && isExact) {
      // Only pass actual values to the reducer
      setFallbackUrl(fallbackUrl);
    }
  }, [fallbackUrl, isExact, setFallbackUrl]);
};
